import { FCRAWorkerCheckRecordTypeEnum } from '@/types/turn-enums';

export const SEX_OFFENDER = FCRAWorkerCheckRecordTypeEnum.SexOffender;
